import type { AxiosInstance } from 'axios';
import { tokenStore } from '@/shared/api/token-store';
import type { ApiRequestConfig } from '@/shared/api/types';

export function applyAuthInterceptor(client: AxiosInstance): void {
  client.interceptors.request.use((config) => {
    const apiConfig = config as ApiRequestConfig;
    if (apiConfig.skipAuth) return config;

    const token = tokenStore.get();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
}
